import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { Grid, Box } from '@material-ui/core';
import messages from 'containers/LawyerFeeNote/messages';
import { translate } from 'containers/services/translate';

export interface ChecksBoxProps {
  intl: IntlShape;
  regulations: any;
  checkNumber: string;
}

export const ChecksBox: React.FC<ChecksBoxProps> = (props): JSX.Element => {
  return (
    <div>
      <Grid container spacing={1}>
        <Grid item xs={3}>
          <Box bgcolor="white" className="cheque-fields-box">
            <Grid container direction="column">
              <Grid item>
                <span className="title-check-fields">
                  {translate(messages.checkNumber, props)}
                </span>
              </Grid>
              <Grid item>
                <span>{props.checkNumber}</span>
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </div>
  );
};

export default injectIntl(ChecksBox);
